import store from '../redux/store'
export default store
